import '@apollo/client'
import {
  ButtonBase,
  IconButton,
  ListItem,
  Menu,
  Typography
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'

import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { WebHookMonitoring, ChannelMonitoring } from '../../types/channelPush'
import MaxMin from './MaxMin'
import MoreInfoModal from './MoreInfoModal'
import StatusBox from './StatusBox'
import useStyles from './styles/channelsTableRow.style'

//

interface ChannelsTableRowProps {
  channel: ChannelMonitoring
  adapter: WebHookMonitoring
  getWebHookLabelByValue: (value: string) => string | undefined
  isOdd: boolean
}

export const ChannelsTableRow: React.FC<ChannelsTableRowProps> = ({
  channel,
  adapter,
  isOdd,
  getWebHookLabelByValue
}) => {
  const classes = useStyles({ isOdd })
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()
    setAnchorEl(null)
  }
  const [viewRequestIsOpen, setviewRequestIsOpen] = useState<boolean>(false)
  const [viewResponseIsopen, setviewResponseIsopen] = useState<boolean>(false)

  const {
    adaptor,
    healthStatus,
    lastFetched,
    lastRequest,
    lastResponse,
    lastSent,
    state
  } = adapter

  const { channelCode, channelId, channelName } = channel
  const isPersian = persianRegex.test(channelName)
  return (
    <div className={classes.tableRow}>
      <ButtonBase
        component={LocalizedLink}
        to={`/channels/${channelId}/${channelCode}/push`}
        className={classes.tableRowExceptMenuItem}>
        <div>
          <Typography
            variant="h4"
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {channelName}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getWebHookLabelByValue(adaptor)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {<StatusBox status={healthStatus} />}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate(state)}</Typography>
        </div>
        <div className={classes.lastFetched}>
          <MaxMin
            duration={lastFetched.max.delay}
            name={lastFetched.max.accName}
            title="Max"
          />
          <MaxMin
            duration={lastFetched.min.delay}
            name={lastSent.min.accName}
            title="Min"
          />
        </div>
        <div className={classes.lastFetched}>
          <MaxMin
            duration={lastSent.max.delay}
            name={lastFetched.max.accName}
            title="Max"
          />
          <MaxMin
            duration={lastSent.min.delay}
            name={lastSent.min.accName}
            title="Min"
          />
        </div>
      </ButtonBase>
      <div className={classes.menuIcon}>
        <IconButton
          onClick={(event) => {
            handleClick(event)
          }}>
          <MoreIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <ListItem
            button
            onClick={(event) => {
              event.preventDefault()
              setviewRequestIsOpen(true)
            }}>
            {getTranslate('View Request')}
          </ListItem>
          <ListItem
            button
            onClick={(event) => {
              event.preventDefault()
              setviewResponseIsopen(true)
            }}>
            {getTranslate('View Response')}
          </ListItem>
        </Menu>
        <MoreInfoModal
          requestView={
            typeof lastRequest === 'object' && lastRequest !== null
              ? JSON.parse(lastRequest)
              : JSON.parse('{}')
          }
          isOpen={viewRequestIsOpen}
          onClose={() => setviewRequestIsOpen(false)}
        />
        <MoreInfoModal
          requestView={
            typeof lastResponse === 'object' && lastResponse !== null
              ? JSON.parse(lastResponse)
              : JSON.parse('{}')
          }
          isOpen={viewResponseIsopen}
          onClose={() => setviewResponseIsopen(false)}
        />
      </div>
    </div>
  )
}
